import React, { JSX } from 'react';

type Props = {
  header: JSX.Element;
  main: JSX.Element;
  footer: JSX.Element;
  children?: React.ReactNode;
};

export const HeaderMainFooterLayout = ({ header, main, footer }: Props) => {
  return (
    <div className="content">
      {header}
      {main}
      {footer}
    </div>
  );
};
